import React, { useMemo, useState } from "react";

import Button from "components/common/Button/Button";

interface IProps {
  leftCaption?: string;
  rightCaption?: string;
  leftClick?(): void;
  rightClick?(): void;
}

export default function WizardButtonGroup({
  leftCaption,
  leftClick,
  rightCaption,
  rightClick
}: IProps): JSX.Element {
  return (
    <div>
      {leftCaption && (
        <Button primary onClick={leftClick} style={{ marginRight: "14px" }}>
          {leftCaption}
        </Button>
      )}
      {rightCaption && (
        <Button tertiary onClick={rightClick}>
          {rightCaption}
        </Button>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/WizardButtonGroup/WizardButtonGroup.tsx